"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IGender = void 0;
var IGender;
(function (IGender) {
    IGender["Male"] = "male";
    IGender["Female"] = "female";
})(IGender || (exports.IGender = IGender = {}));
//# sourceMappingURL=gender.js.map